import React, { useState } from 'react'

import type { MembersEnrollment } from 'utils/web_api.schemas'

import EnrollmentDetails from './EnrollmentDetails/EnrollmentDetails'

interface EnrollmentsCarouselProps {
  enrollments: MembersEnrollment[] | undefined,
  isPriorYear: boolean
}

const EnrollmentsCarousel: React.FC<EnrollmentsCarouselProps> = ({
  enrollments,
  isPriorYear
}) => {
  const [currentIndex, setCurrentIndex] = useState(0)

  // Reset to first enrollment when enrollments change
  React.useEffect(() => {
    setCurrentIndex(0)
  }, [enrollments])

  if (!enrollments || enrollments.length === 0) {
    return null
  }

  const canGoBack = currentIndex > 0
  const canGoForward = currentIndex < enrollments.length - 1
  const showNavigation = enrollments.length > 1

  const handlePrevious = () => {
    setCurrentIndex(prev => Math.max(0, prev - 1))
  }

  const handleNext = () => {
    setCurrentIndex(prev => Math.min(enrollments.length - 1, prev + 1))
  }

  const carouselProps = {
    currentPlanNumber: currentIndex + 1,
    totalPlanCount: enrollments.length,
    canGoBack,
    canGoForward,
    handlePrevious,
    handleNext
  }

  return (
    <EnrollmentDetails
      enrollment={enrollments[currentIndex]}
      isPriorYear={isPriorYear}
      showNavigation={showNavigation}
      carouselProps={carouselProps}
    />
  )
}

export default EnrollmentsCarousel
